import React from "react";

const NoMatch = () => <div>This route does not exist</div>;

export default NoMatch;
